import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { X } from 'react-feather';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import classnames from 'classnames';
import styles from 'styles/Layout.module.scss';
import * as Icon from 'react-feather';

const ModalSchedule = (props) => {
  const { previewModal, setPreiewModal, schedule, viewHandler, dateConvert } =
    props;
  return (
    <div>
      <Modal
        size="lg"
        show={previewModal}
        // style={{ marginBlockStart: '6rem' }}
      >
        <Modal.Header>
          <h3>Scheduled List</h3>
          <span color="secondary" outline onClick={() => setPreiewModal(false)}>
            <X />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            <div className="row">
              {schedule?.length > 0 ? (
                schedule?.map((item) => (
                  <div
                    className="card col-md-12 cursor-pointer p-1"
                    style={{ border: '1px sold black' }}
                    onClick={() => viewHandler(item)}
                  >
                    <div className="row" style={{ marginTop: '8px' }}>
                      <div className="col">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{ display: 'flex' }}
                          >
                            <Icon.Target size={18} />
                            <h5 className="ml-1">{item?.intake[0]?.name}</h5>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 pl-4 ">
                        <div
                          className="row mx-0 align-items-center "
                          style={{ marginTop: '5px' }}
                        >
                          <div className="col-md-3 schedule-popup-res  px-0">
                            <Icon.Calendar
                              size={15}
                              style={{ marginTop: -4 }}
                            />

                            <span className="ml-05">
                              {dateConvert(item?.date)}
                            </span>
                          </div>
                          <div
                            style={{ '--gap': '.5rem' }}
                            className="col-md-3 schedule-popup-res d-flex align-items-center dynamic-gap-v px-0"
                          >
                            <Icon.Clock size={15} />

                            <span>
                              {`${item?.time?.begin} - ${item?.time?.end}`}
                            </span>
                          </div>
                          <div className="col-md-2 schedule-popup-res px-0">
                            <span>
                              <PaymentsOutlinedIcon size={15} />
                            </span>
                            <span className="ml-05">
                              ${' '}
                              {item.ratePerHour
                                ? item.ratePerHour
                                : item.ratePerStudent}
                            </span>
                          </div>
                          <div
                            className={classnames(
                              'col d-flex justify-content-end',
                              styles['schedule-pending'],
                            )}
                          >
                            <label htmlFor="" className="text-white px-1 ">
                              {item?.timesheet.length > 0
                                ? item?.timesheet[0].status
                                : 'PENDING'}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-md-12">
                  <p style={{ textAlign: 'center' }}>No Schedule available</p>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalSchedule;
